/**
 * @fileoverview Os passos da esteira de cadastro depois da conta (etapa 5 dos
 * planos), dentro do app: a IA (o assistente que já existe), o WhatsApp, a
 * equipe e o resumo do fim. Cada passo vencido fica guardado no servidor
 * (POST /onboarding/setup/step), e a esteira continua dali ao voltar. O fim
 * (POST /onboarding/setup/finish) fecha a esteira e leva ao painel, onde o
 * checklist mostra o que ficou para depois. Quem não está com a esteira em
 * aberto vai para a tela inicial.
 */

import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import AiSetupAssistant from "../../components/AiSetupAssistant";
import SetupProgress from "../../components/CompanySetup/SetupProgress";
import WhatsAppStep from "../../components/CompanySetup/WhatsAppStep";
import TeamStep from "../../components/CompanySetup/TeamStep";
import DoneStep from "../../components/CompanySetup/DoneStep";
import useSetupStyles from "../../components/CompanySetup/styles";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const SetupSteps = () => {
  const classes = useSetupStyles();
  const history = useHistory();
  const [setup, setSetup] = useState(null);
  const [view, setView] = useState(null);
  const [invitesSent, setInvitesSent] = useState(0);
  const [finishing, setFinishing] = useState(false);

  const load = useCallback(async () => {
    const { data } = await api.get("/onboarding/setup");
    if (data.stage !== "steps") {
      history.replace("/");
      return null;
    }
    setSetup(data);
    return data;
  }, [history]);

  useEffect(() => {
    load()
      .then((data) => data && setView(data.step || "ai"))
      .catch((err) => {
        toastError(err);
        history.replace("/");
      });
  }, [load, history]);

  // O próximo passo fica guardado (a esteira continua dali); o resumo relê o que já está pronto.
  const go = async (next) => {
    try {
      if (next === "done") {
        await load();
      } else {
        const { data } = await api.post("/onboarding/setup/step", { step: next });
        setSetup(data);
      }
      setView(next);
      window.scrollTo(0, 0);
    } catch (err) {
      toastError(err);
    }
  };

  const finish = async () => {
    setFinishing(true);
    try {
      const { data } = await api.post("/onboarding/setup/finish");
      // Escolheu o Basic ou o Pro no site: a contratação dele abre em Faturamento.
      history.push(data && data.contractPlan ? `/settings/billing?plan=${data.contractPlan}` : "/dashboard");
    } catch (err) {
      toastError(err);
      setFinishing(false);
    }
  };

  return (
    <div className={classes.page}>
      <div className={classes.inner}>
        {!setup || !view ? (
          <div className={classes.loading}>
            <CircularProgress size={24} />
          </div>
        ) : (
          <>
            <SetupProgress current={view} />
            {view === "ai" && <AiSetupAssistant onFinish={() => go("whatsapp")} onSkip={() => go("whatsapp")} />}
            {view === "whatsapp" && <WhatsAppStep emailVerified={setup.emailVerified} onEmailConfirmed={load} onNext={() => go("team")} />}
            {view === "team" && (
              <TeamStep
                emailVerified={setup.emailVerified}
                onNext={(count) => {
                  setInvitesSent(count);
                  go("done");
                }}
              />
            )}
            {view === "done" && <DoneStep setup={setup} invitesSent={invitesSent} finishing={finishing} onFinish={finish} />}
          </>
        )}
      </div>
    </div>
  );
};

export default SetupSteps;
